import Page from 'components/Page/Page.js'
import React from 'react'
import useAdvancedSearch from 'logic/AdvancedSearch/useAdvancedSearch.js'
import {DANCE_OPTIONS} from 'constants/search.js'
import Autocomplete from 'components/Control/Autocomplete/Autocomplete.js'
import SearchInput from 'components/Control/Input/SearchInput.js'
import AutocompleteCheckbox from 'components/Control/Autocomplete/AutocompleteCheckbox.js'
import Table from 'components/Control/Table.js'
import styled from 'styled-components'

const AdvancedSearch = () => {
    const {
        searchTerm,
        isLoading,
        isArtistsLoading,
        isChoreographers,
        selectedStyles,
        handleDanceNameChange,
        handleStyleChange,
        handleChoreographerSelected,
        handleArtistSelected,
        handleArtistChange,
        handleChoreographerChange,
        handleRowClick,
        artists,
        choreographers,
        rows,
        columns,
        t18AdvancedSearch,
    } = useAdvancedSearch()

    return (
        <Page title={t18AdvancedSearch('search')}>
            <Container>
                <InputsContainer>
                    <SearchInput
                        label={t18AdvancedSearch('danceName')}
                        value={searchTerm}
                        onChange={handleDanceNameChange}
                        isLoading={isLoading}
                        sx={{width: 500}}
                    />
                    <Autocomplete
                        options={choreographers}
                        onInputChange={handleChoreographerChange}
                        onChange={handleChoreographerSelected}
                        isOptionEqualToValue={(option, value) =>
                            option.name === value.name
                        }
                        getOptionLabel={(option) => option.fullName}
                        label={t18AdvancedSearch('choreographer')}
                        isLoading={isChoreographers}
                        sx={{width: 500}}
                    />
                    <Autocomplete
                        options={artists}
                        onInputChange={handleArtistChange}
                        onChange={handleArtistSelected}
                        isOptionEqualToValue={(option, value) =>
                            option.name === value.name
                        }
                        getOptionLabel={(option) => option.hebName}
                        label={t18AdvancedSearch('lyricistOrComposer')}
                        isLoading={isArtistsLoading}
                        sx={{width: 500}}
                    />
                    <AutocompleteCheckbox
                        options={DANCE_OPTIONS}
                        value={selectedStyles}
                        onChange={handleStyleChange}
                        label={t18AdvancedSearch('filterByStyle')}
                        sx={{width: 500}}
                    />
                </InputsContainer>
                <TableContainer>
                    <Table
                        height="80vh"
                        columns={columns}
                        rows={rows}
                        onRowClick={handleRowClick}
                    />
                </TableContainer>
            </Container>
        </Page>
    )
}

export default AdvancedSearch

const Container = styled.div`
    display: flex;
    width: 100%;
`

const InputsContainer = styled.div`
    flex: 1;
    gap: 20px;
    display: flex;
    flex-direction: column;
`

const TableContainer = styled.div`
    flex: 2;
`
